import { render, staticRenderFns } from "./business_type.vue?vue&type=template&id=df0d6efa&scoped=true"
import script from "./business_type.vue?vue&type=script&lang=js"
export * from "./business_type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0d6efa",
  null
  
)

export default component.exports